<template>
  <div 
    v-on:click="$emit('handleClick')"
    v-bind:class="{ 'button-bgcolor': active }"
    class="button"
  >
    <router-link
      v-if="to !== ''"
      :to="to"
      :title="title"      
    >
      <ChevronLeftIcon v-if="showChevron && title === 'Prev'"/>

      <AddIcon v-if="showAddIcon"/>

      <span>{{ title }}</span>

      <ChevronRightIcon v-if="showChevron && title !== 'Prev'"/>
    </router-link>

    <div v-else>
      <ChevronLeftIcon v-if="showChevron && title === 'Prev'"/>

      <AddIcon v-if="showAddIcon"/>

      <span>{{ title }}</span>

      <ChevronRightIcon v-if="showChevron && title !== 'Prev'"/>
    </div>
  </div>
</template>

<script>
  import AddIcon from '../../icons/add.vue'
  import ChevronLeftIcon from '../../icons/chevronLeft.vue'
  import ChevronRightIcon from '../../icons/chevronRight.vue'

  export default {
    name: 'Button',
    components: {
      AddIcon,
      ChevronLeftIcon,
      ChevronRightIcon
    },
    props: [
      'title',
      'to',
      'active',
      'showAddIcon',
      'showChevron'
    ]
  }
</script>

<style lang="scss">
  .button {
    display: inline-block;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 5px 10px;
    cursor: pointer;

    span {
      font-weight: bold;
    }

    .add-icon {
      margin-right: 10px;
      margin-top: 2px;
    }

    .chevron-right {
      margin-left: 5px;
    }

    .chevron-left {
      margin-right: 5px;
    }
  }

  .button-bgcolor {
    background-color: var(--blue);
    display: inline-block;
    transition: 0.2s;
    
    span {
      color: var(--white);
      font-weight: normal;
    }

    .chevron-left,
    .chevron-right {
      path {
        fill: var(--white);
      }
    }

    &:hover {
      opacity: 0.8;
    }
  }
</style>